import { isString } from '@yescapa-dev/ysc-api-js/modern'

const typeIntTranslationKeyMap: Record<number, string> = {
  1: 'components.app_search.filters.vehicle_type_description_1',
  2: 'components.app_search.filters.vehicle_type_description_2',
  3: 'components.app_search.filters.vehicle_type_description_3',
  4: 'components.app_search.filters.vehicle_type_description_4',
  5: 'components.app_search.filters.vehicle_type_description_5',
  6: 'components.app_search.filters.vehicle_type_description_6',
  7: 'components.app_search.filters.vehicle_type_description_7',
}
export const useGetTranslatedVehicleDescriptionForTypeInt = () => {
  const { $i18n: { t } } = useNuxtApp()
  return {
    getTranslatedVehicleDescriptionForTypeInt: (typeInt: number | string | null | undefined) => {
      if (!typeInt) {
        return null
      }

      if (isString(typeInt)) {
        typeInt = parseInt(typeInt)
      }

      const key = typeIntTranslationKeyMap[typeInt]
      return key ? t(key) : typeInt
    },
  }
}
